import { lazyLoad } from '@utils/router'
import Login from '@views/Login/Login'
import CommonLogin from '@views/Login/CommonLogin'
import OneLogin from '@views/Login/OneLogin'
import OneLoginIfForm from '@views/Login/OneLogin/OneLoginIfForm'
import BindPhone from '@views/Login/BindPhone'
import { ModuleEnum } from '../const'

/** 公共路由 */
export default [
  {
    path: '/',
    exact: true,
    component: Login,
  },
  {
    /** 登录页 */
    path: '/login/:from?',
    component: Login,
  },
  {
    /** 文件预览 */
    path: '/filePreview/:fileId',
    component: lazyLoad(() => import('@views/KnowledgeLib/pages/FilePreview')),
  },
  {
    /** 智门户文件预览 */
    path: '/myTrainingFilePreview/:fileBrowseUrl',
    component: lazyLoad(() => import('@views/MyTrainingDetail/FilePreview')),
  },
  {
    /** 一账通登录 */
    path: '/one-login',
    component: OneLogin,
  },
  {
    /** 中车统一登录 */
    path: '/sifang-login',
    component: CommonLogin,
  },
  {
    /** 协议查看 */
    path: '/agreement/:agreementType?',
    component: lazyLoad(() => import('@views/Login/Agreements')),
  },
  {
    /** 一账通登录iframe过渡页 */
    path: '/oneLogin',
    component: OneLoginIfForm,
  },
  {
    /** 一账通绑定手机号 */
    path: '/binding/:token',
    component: BindPhone,
  },
  {
    path: '/register/:from?',
    component: lazyLoad(() => import('@views/Login/Register')),
  },
  {
    path: '/retrievePassword/:from?',
    component: lazyLoad(() => import('@views/Login/RetrievePassword')),
  },
  {
    /** 单点登录 */
    path: '/singleLogin',
    component: lazyLoad(() => import('@views/Login/SingleLogin')),
  },
  {
    /** 没有企业身份/首页显示 */
    path: '/noPermission/:type',
    component: lazyLoad(() => import('@views/NoPermission')),
  },
  {
    path: '/liveroom/:roomId/:liveRoomType/:crumbs?',
    component: lazyLoad(() => import('@views/WebLive/LiveRoom')),
  },
  {
    path: '/home/MyNews',
    component: lazyLoad(() => import('@views/MyNews')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/bankliveroom/:sid/:userId/:roomId/:liveRoomType',
    component: lazyLoad(() => import('@views/WebLive/LiveRoom/BankSDKIndex')),
  },
  {
    path: '/cmsLitevideo/:shortVideoId/:sid/:userId/:viewFrom?',
    // path: '/cmsLitevideo',
    component: lazyLoad(() => import('@views/WebLive/LiveRoom/CMSShortVideo')),
  },
  // 口令直播游客模式
  {
    path: '/touristlive/:roomId/:liveRoomType/:crumbs?',
    component: lazyLoad(() => import('@views/WebLive/LiveRoom/TouristLive')),
  },
  // 培训项目直播跳转
  {
    path: '/trainlive/:roomId/:liveRoomType/:crumbs/:trainingItemId',
    component: lazyLoad(() => import('@views/WebLive/LiveRoom/TrainLive')),
  },
  // 回放时间标记
  {
    path: '/replayTips/:roomId',
    component: lazyLoad(() => import('@views/WebLive/LiveRoom/ReplayTips')),
  },
  // 短视频
  {
    path: '/litevideo/:shortVideoId/:pageNo/:pageSize/:apiType/:search?',
    component: lazyLoad(() => import('@views/WebLive/LiveRoom/LiteVideo')),
  },
  {
    path: '/coursePlay/:resourceId',
    component: lazyLoad(() => import('@views/CourseDetail/courseViewSDK')),
  },
  {
    path: '/infoDetail/:id',
    component: lazyLoad(() => import('@views/Login/LongLogin/infoDetail')),
  },
  {
    path: '/long-login',
    component: lazyLoad(() => import('@views/Login/LongLogin')),
  },
  {
    path: '/home/search',
    component: lazyLoad(() => import('@views/Search')),
  },
  {
    path: '/home/comCourseSearch',
    component: lazyLoad(() => import('@views/Search/EnterPriseList')),
    module: ModuleEnum.COURSE,
  },
  {
    path: '/home/liveSearch',
    component: lazyLoad(() => import('@views/Search/LiveList')),
    module: ModuleEnum.LIVE,
  },
  {
    path: '/home/shortVideoSearch',
    component: lazyLoad(() => import('@views/Search/ShortVideo')),
    module: ModuleEnum.SHORTVIDEO,
  },
  {
    path: '/home/playBackSearch',
    component: lazyLoad(() => import('@views/Search/PlayBackList')),
    module: ModuleEnum.LIVE,
  },
  {
    path: '/home/trainingClassSearch',
    component: lazyLoad(() => import('@views/Search/TrainingList')),
    module: ModuleEnum.TRAIN,
  },
  {
    path: '/home/subjectSearch',
    component: lazyLoad(() => import('@views/Search/SeminarList')),
    module: ModuleEnum.COURSE,
  },
  {
    path: '/home/infoSearch',
    component: lazyLoad(() => import('@views/Search/InforList')),
    module: ModuleEnum.INFO,
  },
  {
    path: '/home/knowledgeSearch',
    component: lazyLoad(() => import('@views/Search/KnowledgeList')),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/fileSearch',
    component: lazyLoad(() => import('@views/Search/FileList')),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/topicSearch',
    component: lazyLoad(() => import('@views/Search/TopicList')),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/postSearch',
    component: lazyLoad(() => import('@views/Search/PostList')),
    module: ModuleEnum.KNOWLEDGE,
  },
  // pc连接过来使用地图
  {
    path: '/pcLink',
    component: lazyLoad(() => import('@views/WebLive/LiveList/pcLink')),
    module: 'PCLINK',
  },
  // pc端分享视频会议链接
  {
    path: '/invatationMeeting',
    component: lazyLoad(() =>
      import('@views/WebLive/LiveList/pcLink/pcMeeting')
    ),
    module: 'PCMEETING',
  },
  {
    path: '/project/learnCard',
    component: lazyLoad(() => import('@views/projectLearnCard')),
  },
  process.env.NODE_ENV === 'development' && {
    path: '/iconDemo',
    component: lazyLoad(() => import('@components/Icon/IconList')),
  },
  {
    path: '/guideToChrome',
    component: lazyLoad(() => import('@views/GuideToChrome')),
    module: 'GUIDETOCHROME',
  },
  {
    path: '/rankDetail/:rankingId',
    component: lazyLoad(() => import('@views/RankDetail')),
  },
].filter(Boolean)
